@if (cost.isLoading()) {
  <app-dashboard-summary-card-skeleton />
} @else {
  <div
    class="border border-outline dark:border-outline-darkmode rounded-lg py-5 px-6 flex flex-col gap-5 h-full w-full"
  >
    @if (cost.error()) {
      <app-error-component class="block h-full" />
    } @else {
      <div class="flex gap-2 items-center">
        <h4 class="flex-1">
          {{ 'cockpit.dashboard.costSummaryCard.titleFirstPart' | transloco }}
          <b class="font-semibold">{{
            'cockpit.dashboard.costSummaryCard.titleBoldPart' | transloco
          }}</b>
          {{ 'cockpit.dashboard.costSummaryCard.titleLastPart' | transloco: { year: year() } }}
        </h4>
        <ui-switch-bar class="w-[78px] inline-block" [formField]="settingsForm.utilityType">
          <ui-switch-bar-option value="ELECTRICITY">
            <ng-icon name="heroBolt" size="20" class="!block" />
          </ui-switch-bar-option>
          <ui-switch-bar-option value="GAS">
            <ng-icon name="heroFire" size="20" class="!block" />
          </ui-switch-bar-option>
        </ui-switch-bar>
      </div>
      <div class="text-end">
        @if (cost.hasValue()) {
          @let range = costValue();
          @let avg = (range.min + range.max) / 2 / 100;
          <app-responsive-value [value]="avg === 0 ? '-' : (avg | germanNumber: 2)">{{
            'cockpit.dashboard.costSummaryCard.currency' | transloco
          }}</app-responsive-value>
        }
      </div>
    }
  </div>
}
